import { useEffect, useState } from "react";
import { UserPlus, ChevronDown } from "lucide-react";
import { getDevelopers } from "src/features/MiniCRM/CachedData";

export default function OwnersToolbar({ onAddOwner, workspaceId }) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  useEffect(() => {
    if (workspaceId)
    loadUsers();
  }, []);

  async function loadUsers() {
    try {
      const data = await getDevelopers(workspaceId);
      setUsers(data || []);
    } catch (error) {
      console.error("Failed to load users", error);
    }
  }

  const handleSelect = (e) => {
    const userId = e.target.value;
    setSelectedUser(userId);
    if (!userId) return;

    const user = users.find((u) => u.user_id === userId);
    if (user && onAddOwner) {
      onAddOwner(user);
    }
    setSelectedUser("");
  };

  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-6 sm:px-8 pt-4">
      <h3 className="font-sans text-sm font-semibold text-slate-800 tracking-tight">
        Assign Owners to Stages
      </h3>

      <div className="relative w-full sm:w-64">
        <UserPlus className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />

        <select
          value={selectedUser}
          onChange={handleSelect}
          className="w-full appearance-none rounded-lg border border-slate-200 bg-white py-2 pl-9 pr-10 text-sm font-medium text-slate-700 shadow-sm transition-all duration-200 hover:border-slate-300 hover:bg-slate-50/50 focus:border-primary focus:outline-none focus:ring-4 focus:ring-primary/10"
        >
          <option value="">Add Owner</option>
          {users.map((user) => (
            <option key={user.user_id} value={user.user_id}>
              {user.user?.name}
            </option>
          ))}
        </select>

        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      </div>
    </div>
  );
}